import {DotLottieReact} from '@lottiefiles/dotlottie-react'

import spinnerLottie from '@/assets/lotties/spinner.lottie'
import SkipLink from '@/components/SkipLink'
import {LOADING} from '@/constants/magicStrings'
import Footer from '@/layout/Footer'
import Navbar from '@/layout/Navbar'
import {sendMessage} from '@/lib/cobrowse/cobrowse'
import HeadTags from '@/lib/head/HeadTags'
import {useLocale} from '@/lib/locale/locale'
import {type FullProduct} from '@/models/productModel'
import queries from '@/queries/queries'
import type {ProductId} from '@/routes/product/$productId'
import skipTargetProps from '@/utils/a11y/skipTargetProps'

import ProductInfoAndOptions from './components/ProductInfoAndOptions'
import ProductReviews from './components/ProductReviews'
import ProductVisual from './components/ProductVisual'
import style from './Product.module.scss'

interface Props {
  isLoading: false
  productId?: ProductId
  product: FullProduct
  isFetching: boolean
  setProductId: MemoizedCallbackOrDispatch<ProductId>
  unavailableProductIds: Set<string>
  markProductIdsAsUnavailable: MemoizedCallbackOrDispatch<ProductId[]>
  threadId?: string
  variationThreadId?: string
  suggestedPrompts: string[]
  refetchProduct?: MemoizedCallback<() => void>
}

interface EmptyProps {
  isLoading: true
  productId?: ProductId
}

export default memo(function ProductUI(props: Props | EmptyProps) {
  const [locale] = useLocale()

  // const askRef = useRef<AskInnoSearchControl>(null)

  // useEffect(
  //   function updateVariationThreadId() {
  //     if (!('variationThreadId' in props) || !askRef.current) return
  //     console.log('updateVariationThreadId', props.variationThreadId)
  //     askRef.current.updateVariationThreadId(props.variationThreadId)
  //   },
  //   [props],
  // )

  // const ask = useCallback((q: string) => {
  //   askRef.current?.ask(q)
  // }, [])

  const {data: title} = useQuery(
    queries.getObserveQueryOptions({
      name: 'product',
      params: props.productId
        ? [props.productId.retailer, props.productId.id, locale]
        : ['', '', locale],
      select: data => {
        if (data) {
          return data.title
        }
      },
    }),
  )

  return (
    <>
      <HeadTags title={props.isLoading ? (title ?? LOADING) : props.product.title} />
      <div className={style.Page}>
        <SkipLink title='Skip to main content' to='#main-content' />
        <Navbar withSearch displayNavBanner variant='dark' />
        <main className={style.ProductPage} {...skipTargetProps('main-content')}>
          {props.isLoading && (
            <div className={style.SpinnerContainer}>
              <DotLottieReact
                src={spinnerLottie}
                autoplay
                loop
                className={style.Spinner}
                aria-label='Loading product...'
                role='progressbar'
              />
            </div>
          )}
          {!props.isLoading && (
            <>
              <div className={style.ProductDetails}>
                <ProductVisual
                  images={props.product.images}
                  title={props.product.title}
                  ask={sendMessage}
                />
                <ProductInfoAndOptions
                  isLoading={props.isFetching}
                  product={props.product}
                  setProductId={props.setProductId}
                  unavailableProductIds={props.unavailableProductIds}
                  markProductIdsAsUnavailable={props.markProductIdsAsUnavailable}
                  refetchProduct={props.refetchProduct}
                />
              </div>
              <ProductReviews reviews={props.product.reviews} />
            </>
          )}
        </main>
        {/* {!props.isLoading && !!props.threadId && (
          <AskInnoSearch threadId={props.threadId} prompts={props.suggestedPrompts} ref={askRef} />
        )} */}
        <Footer />
      </div>
    </>
  )
})
